import PropTypes from "prop-types";
import React from "react";
import { NavDropdown } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

const LanguageSelector = ({ changeLanguage, language }) => {
  const intl = useIntl();
  return (
    <NavDropdown
      id="language-selector"
      align="end"
      onSelect={changeLanguage}
      title={
        language === "de"
          ? intl.formatMessage({ id: "language.german" })
          : intl.formatMessage({ id: "language.english" })
      }
    >
      <NavDropdown.Item eventKey="en" active={intl.locale === "en"}>
        <FormattedMessage id="language.english" />
      </NavDropdown.Item>
      <NavDropdown.Item eventKey="de" active={intl.locale === "de"}>
        <FormattedMessage id="language.german" />
      </NavDropdown.Item>
    </NavDropdown>
  );
};
LanguageSelector.propTypes = {
  changeLanguage: PropTypes.func,
  language: PropTypes.string.isRequired
};

export default LanguageSelector;
